import './index.scss';
import { RootState } from '../../redux/AppReducer';
import { useSelector } from 'react-redux';
import { FC, useEffect } from 'react';
import { ProgressComponent } from '../../components/UI/ProgressComponent/ProgressComponent';
import { AppActions } from '../../redux/AppActions';
import { useAppDispatch } from '../../redux/store';

const LandingPage: FC = () => {
	const dispatch = useAppDispatch();
	const setStandAloneLayout = (standAloneLayout: boolean) =>
		dispatch(AppActions.setStandAloneLayout(standAloneLayout));
	const startLoadingProgress = () => dispatch(AppActions.startProgress());
	const setLoadProfileProgress = (progress: number) =>
		dispatch(AppActions.setLoadProfileProgress(progress));
	const cancellInterval = () => dispatch(AppActions.intervalCancelation());
	const loadProfileProgress = useSelector(
		({ appState: state }: RootState) => state.loadProfileProgress
	);
	useEffect(() => {
		startLoadingProgress();
		setStandAloneLayout(true);
		return () => {
			setStandAloneLayout(false);
			setLoadProfileProgress(0);
			cancellInterval();
		};
	}, []);
	return (
		<div className='loader-container'>
			<ProgressComponent progress={loadProfileProgress || 0} max={100} />
		</div>
	);
};

export default LandingPage;
